__turbopack_context__.v({
  "country-code": "FlagSelector-module-scss-module__E2D99a__country-code",
  "flag-container": "FlagSelector-module-scss-module__E2D99a__flag-container",
  "flag-details-container": "FlagSelector-module-scss-module__E2D99a__flag-details-container",
  "flag-list-item": "FlagSelector-module-scss-module__E2D99a__flag-list-item",
  "flag-selector": "FlagSelector-module-scss-module__E2D99a__flag-selector",
  "no-match-message": "FlagSelector-module-scss-module__E2D99a__no-match-message",
  "search-bar-container": "FlagSelector-module-scss-module__E2D99a__search-bar-container",
});
